import { Injectable } from '@angular/core';
import { DataService } from '../../data/data.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

const url     = 'api/Product';
const BaseUrl = environment.BaseUrl ;

@Injectable({
  providedIn: 'root'
})
export class ProductsService extends DataService {

  constructor(http: HttpClient) {
    super(url, BaseUrl, http, "Product" );
   }
}
